import type { ButtonProps } from './Button';
import type { Ref } from 'react';

import { forwardRef } from 'react';
import { styled } from 'styled-components';

import { DefaultButtonSC } from './Button';

type Props = Omit<ButtonProps, 'leftIcon' | 'rightIcon' | 'size'>;

const IconButtonSC = styled(DefaultButtonSC)`
  padding: 0.5rem;
  height: auto;
  width: auto;
  min-width: auto;
  min-height: auto;
  background-color: transparent;

  &:focus,
  &:hover {
    box-shadow: none;
    svg {
      color: ${(props) => props.theme.colors.emeraldGreen[100]};
    }
  }

  &:focus-visible {
    box-shadow: 0 0 0 0.1875rem ${(props) => props.theme.colors.emeraldGreen[50]};
  }

  &[disabled],
  &:disabled {
    svg {
      color: ${(props) => props.theme.colors.oxfordBlue[30]};
    }
  }

  svg {
    color: ${(props) => props.theme.colors.oxfordBlue[100]};
    width: 1.5rem;
    height: 1.5rem;
  }
`;

export const IconButton = forwardRef(({ children, ...props }: Props, ref: Ref<HTMLButtonElement>) => {
  return (
    <IconButtonSC ref={ref} {...props}>
      {children}
    </IconButtonSC>
  );
});
